module.exports = __webpack_public_path__ + "static/media/Mt.FujiJapan-day.0e6f4906.svg";